// extracted by mini-css-extract-plugin
export default {"swaggerWrapper":"BiXujnFutwXRp_QUL6TUC"};